import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PaymentLinkQrCode from "./PaymentLinkQrCode";

interface PaymentLinkQrDialogProps {
  open: boolean;
  url: string;
  fileName: string;
  onClose: () => void;
}

const PaymentLinkQrDialog: React.FC<PaymentLinkQrDialogProps> = ({
  open,
  url,
  fileName,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("QR Code")}</DialogTitle>
      <DialogContent>
        <PaymentLinkQrCode url={url} fileName={fileName} />
      </DialogContent>
      <DialogActions>
        <Button variant="default-outlined" onClick={onClose}>
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentLinkQrDialog;
